import { Directive, Input, TemplateRef } from '@angular/core';

/**
 * Declares a tab for {@link SubNavComponent}. Place on an `ng-template`:
 *
 * ```html
 * <ng-template appSubNavTab label="All Users" automationId="company-all-users-tab">
 *   ...
 * </ng-template>
 * ```
 */
@Directive({
	selector: 'ng-template[appSubNavTab]',
})
export class SubNavTabDirective {
	@Input({ required: true }) label!: string;
	@Input() automationId?: string;

	constructor(public readonly templateRef: TemplateRef<unknown>) {}
}
